import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

const TunnelBigoViewContainer = styled.div`
  background-color: var(--tonal-light);
  overflow: hidden;
  border-radius: 0.25rem;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  width: calc(50% - 0.25rem);
  &.alpha25 {
    background-color: var(--alpha25);
  }
  &.alpha50 {
    background-color: var(--alpha50);
  }
  &.alpha75 {
    background-color: var(--alpha75);
  }
  &.alpha100 {
    background-color: var(--board);
  }
  span {
    background-color: var(--tonal);
    color: var(--text-disabled);
    border-bottom: 1px solid var(--outline);
    padding: 0 0.75rem;
    font-size: 0.75rem;
  }
  div {
    height: 2.25rem;
    padding: 0.5rem 0.75rem;
    font-size: 0.75rem;
    font-weight: 600;
    color: var(--text-tertiary);
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    &.tight {
      padding: 0.375rem 0.5rem;
    }
  }
  &.siteDashboard {
    > div {
      font-size: 0.875rem;
      height: 2.75rem;
      padding: 0 0.75rem;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      line-height: 2.75rem;
    }
  }
`;

const TunnelBigoView = ({
  textType,
  text,
  label = true,
  opacity,
  siteDashboard = false,
}: {
  textType: string;
  text: string;
  label?: boolean;
  opacity?: 'alpha25' | 'alpha50' | 'alpha75' | 'alpha100';
  siteDashboard?: boolean;
}) => {
  const { t } = useTranslation();
  return (
    <TunnelBigoViewContainer className={`${opacity || ''} ${siteDashboard ? 'siteDashboard' : ''}`}>
      {!label && <span>{textType === 'tjc' ? t('작업 내용') : t('장비 상태')}</span>}
      <div className={`${!label ? '' : 'tight'}`}>{text}</div>
    </TunnelBigoViewContainer>
  );
};

export default TunnelBigoView;
